export enum Feature {
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  AINAVIO_CHAT_BOT = 'AINAVIO_CHAT_BOT',
  TENANT_NETWORK_WIDGET = 'TENANT_NETWORK_WIDGET',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
